import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useSearchResults, useSearchState } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<{
	countLocalized: string;
	query: string | undefined;
	count: number;
	isLoading: boolean;
}>;

export function useSearchQueryResultText(): Result {
	const state = useSearchState();
	const results = useSearchResults();
	const { localizeNumber } = useI18n();

	return {
		data: {
			isLoading: results.isLoading || results.isInitialLoad,
			countLocalized: useMemo(() => localizeNumber(results.nbHits), [results.nbHits, localizeNumber]),
			query: state.query || undefined,
			count: results.nbHits,
		},
	};
}
